module.exports = {
    APIKey: '9cb7a857'
};